<template>
    <detailed-message
        :has-details="message.hasDetails"
        :message-id="message.id">
        <template
            slot="summary"
            slot-scope="{toggle, isOpen}">
            <message-summary
                :message="message"
                :is-open="isOpen"
                :type="type"
                :entity-id="entityId"
                @click="e => toggle(e)"/>
        </template>
        <template slot="details">
            <component
                v-for="(table, index) in message.extraData.tables"
                :key="index"
                :table="table"
                :message-type="message.type"
                :is="getType(table)"/>
        </template>
    </detailed-message>
</template>

<script>
    import DetailedMessage from '@/components/timeline/components/detailed-message';
    import MessageSummary from '@/components/timeline/components/message-summary/generic-summary';

    import TwoColumnList from '@/components/timeline/components/messages/generic-message/two-column-list';
    import ThreeColumnTable from '@/components/timeline/components/messages/generic-message/three-column-table';
    import OneColumnTable from '@/components/timeline/components/messages/generic-message/one-column-list';

    import messagesMixins from '@/components/timeline/components/messages/messages-mixins';

    export default {
        name: 'generic-message',
        components: {
            DetailedMessage,
            MessageSummary,
        },
        mixins: [messagesMixins],
        props: {
            type: {
                type: String,
                required: true,
            },
            entityId: {
                type: String,
                required: true,
            },
        },
        methods: {
            getType(table) {
                if (table.isOneColumn) {
                    return OneColumnTable;
                }
                return table.isThreeColumns
                    ? ThreeColumnTable
                    : TwoColumnList;
            },
        },
    };
</script>
